import { useEffect, useState } from 'react';

// Below this width the side-opening dropdown submenus have nowhere to go — most
// notably when Guardian is embedded as a ~500px sidebar iframe — so selectors
// switch to an inline (tree) layout instead of a flyout.
export const NARROW_VIEWPORT_BREAKPOINT_PX = 600;

const QUERY = `(max-width: ${NARROW_VIEWPORT_BREAKPOINT_PX}px)`;

/**
 * True when the viewport is narrow enough that side flyouts get clipped.
 * Falls back to `false` (wide) when matchMedia is unavailable (e.g. tests).
 */
export const useIsNarrowViewport = (): boolean => {
  const [isNarrow, setIsNarrow] = useState<boolean>(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(QUERY).matches : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(QUERY);
    const onChange = (event: MediaQueryListEvent) => setIsNarrow(event.matches);
    setIsNarrow(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isNarrow;
};
